
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/settings",
      function () {
        return require("private-next-pages/admin/settings.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/settings"])
      });
    }
  